import { render } from "./slider.vue?vue&type=template&id=13fb7508&scoped=true"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"

import "./slider.vue?vue&type=style&index=0&id=13fb7508&scoped=true&lang=css"

import exportComponent from "/var/deploy/production_one/web_head/releases/20260608213341/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fb7508"]])

export default __exports__